import React from "react";
import {
  translate,
  Input,
  Button,
  router,
  Link,
  SimpleDropdown,
  LoadingIndicator
} from "clavis-nxt-components-custdevtm";
import _ from "lodash";
import { ShowErrorPopup } from "util/Alert/Alert";
import axios from "axios";
import queryString from "query-string";
import "./RegistrationStyle.scss";
import { navigateToAuthorizeEndpoint } from "clavis-nxt-components-custdevtm/src/util/auth/Auth";
import moment from "moment";

class Registration extends React.Component {
  HOST = JSON.parse(localStorage.getItem("moduleConfig")).modules["custdevtm"]
    .srv;
  HEADER = {
    "Content-Type": "application/json;charset=UTF-8"
  };

  constructor(props) {
    super(props);

    let availableLanguages = [
      {
        name: "EN",
        value: "EN"
      },
      {
        name: "HU",
        value: "HU"
      }
    ];

    let storedLanguage = localStorage.getItem("clavis.language");
    console.log("stored language", storedLanguage);
    let foundLanguage = _.find(availableLanguages, { value: storedLanguage });

    if (!storedLanguage) {
      localStorage.setItem("clavis.language", availableLanguages[1].value);
    }

    this.state = {
      token: "",
      smsOtp: "",
      username: "",
      password: "",
      passwordAgain: "",
      warningSmsOtp: "",
      warningUsername: "",
      warningPassword: "",
      warningPasswordAgain: "",
      sendAgainLoading: false,
      availableLanguages: availableLanguages,
      language: foundLanguage || availableLanguages[1],
      showVerifyForm: true,
      verifyBtnDisabled: false,
      registerBtnDisabled: false,
      aszfConfirmed: false
    };
  }

  componentDidMount() {
    let params = queryString.parse(this.props.location.search);
    this.setState(
      {
        token: params["token"]
      },
      () => {
        if (this.state.token) {
          this.sendSmsOtp();
        }
      }
    );
  }

  sendSmsOtp = () => {
    const { t } = this.props;
    this.setState(
      {
        sendAgainLoading: true
      },
      () => {
        const data = { token: this.state.token };
        axios
          .post(this.HOST + "/action/sendsmsotp", data, {
            headers: this.HEADER
          })
          .then(result => {
            console.info(result);
          })
          .catch(exception => {
            if (exception.status === 400) {
              ShowErrorPopup({
                data: {
                  errorCode: "CLV_CDT_INVALID_TOKEN",
                  details: t("error.CLV_CDT_INVALID_TOKEN")
                }
              });
            } else {
              ShowErrorPopup({
                data: {
                  errorCode: "CLV_CDT_INTERNAL_SERVER_ERROR",
                  details: t("error.CLV_CDT_INTERNAL_SERVER_ERROR")
                }
              });
            }
          });
        setTimeout(() => {
          this.setState({
            sendAgainLoading: false
          });
        }, 2000);
      }
    );
  };

  changeSmsOtp = e => {
    this.setState({
      smsOtp: e
    });
  };

  changeUsername = e => {
    if (e.match("^[öüóőúéáűía-z0-9 ]*$") != null) {
      this.setState({
        username: e
      });
    } else if (e.match("^[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ0-9 ]*$") != null) {
      this.setState({
        username: e.toLowerCase()
      });
    }
  };

  changePassword = e => {
    this.setState({
      password: e,
      registerBtnDisabled: e !== this.state.passwordAgain
    });
  };
  changePasswordAgain = e => {
    this.setState({
      passwordAgain: e,
      registerBtnDisabled: e !== this.state.password
    });
  };

  handleKeyPressVerify = event => {
    if (event.key === "Enter") {
      this.confirm();
    }
  };

  handleKeyPressRegistration = event => {
    if (event.key === "Enter") {
      this.registration();
    }
  };

  confirm = () => {
    const { t } = this.props;
    this.setState(
      {
        verifyBtnDisabled: true
      },
      () => {
        const data = {
          token: this.state.token,
          smsotp: this.state.smsOtp,
          tokenType:
            this.props.actionType === "registration"
              ? "CREATE"
              : "FORGOTTEN_PASSWORD"
        };
        axios
          .post(this.HOST + "/action/checksmsotp", data, {
            headers: this.HEADER
          })
          .then(result => {
            if (result.status === 200) {
              this.setState({
                showVerifyForm: false,
                verifyBtnDisabled: false
              });
            }
          })
          .catch(exception => {
            if (exception.status === 400) {
              ShowErrorPopup({
                data: {
                  errorCode: "CLV_CDT_INVALID_SMS_OTP",
                  details: t("error.CLV_CDT_INVALID_SMS_OTP")
                }
              });
            } else {
              ShowErrorPopup({
                data: {
                  errorCode: "CLV_CDT_INTERNAL_SERVER_ERROR",
                  details: t("error.CLV_CDT_INTERNAL_SERVER_ERROR")
                }
              });
            }
            this.setState({
              verifyBtnDisabled: false
            });
          });
      }
    );
  };

  registration = () => {
    const { t } = this.props;
    this.setState(
      {
        registerBtnDisabled: true
      },
      () => {
        const data = {
          token: this.state.token,
          smsotp: this.state.smsOtp,
          userName: this.state.username,
          password: this.state.password,
          passwordAgain: this.state.passwordAgain
        };

        axios
          .post(this.HOST + "/action/registerUser", data, {
            headers: this.HEADER
          })
          .then(result => {
            if (result.status === 200) {
              console.info(result);
              window.location = `/clavis-nxt-web-platform/login`;
            }
          })
          .catch(exception => {
            if (exception.status === 400) {
              let errorMessage;
              if (exception.data.details) {
                const param =
                  exception.data.details["password"][0].params.param;
                const labelCode =
                  "error." + exception.data.details["password"][0].labelCode;
                errorMessage = param
                  ? t(labelCode, { param: param })
                  : t(labelCode);
              }
              ShowErrorPopup({
                data: {
                  errorCode: exception.data.errorCode,
                  details: errorMessage
                    ? errorMessage
                    : t("error." + exception.data.errorCode)
                }
              });
            } else {
              ShowErrorPopup({
                data: {
                  details: exception,
                  errorCode: "CLV_CDT_INTERNAL_SERVER_ERROR"
                }
              });
            }
          });
        this.setState({
          registerBtnDisabled: false
        });
      }
    );
  };

  changePasswordSend = () => {
    const { t } = this.props;
    this.setState(
      {
        registerBtnDisabled: true
      },
      () => {
        const data = {
          token: this.state.token,
          smsotp: this.state.smsOtp,
          newPassword: this.state.password,
          newPasswordAgain: this.state.passwordAgain
        };

        axios
          .post(this.HOST + "/action/changeForgottenPassword", data, {
            headers: this.HEADER
          })
          .then(result => {
            if (result.status === 200) {
              console.info(result);
              window.location = `/login`;
            }
          })
          .catch(exception => {
            if (exception.status === 400) {
              let errorMessage;
              if (exception.data.details) {
                const param =
                  exception.data.details["password"][0].params.param;
                const labelCode =
                  "error." + exception.data.details["password"][0].labelCode;
                errorMessage = param
                  ? t(labelCode, { param: param })
                  : t(labelCode);
              }
              ShowErrorPopup({
                data: {
                  errorCode: exception.data.errorCode,
                  details: errorMessage
                    ? errorMessage
                    : t("error." + exception.data.errorCode)
                }
              });
            } else {
              ShowErrorPopup({
                data: {
                  details: exception,
                  errorCode: "CLV_CDT_INTERNAL_SERVER_ERROR"
                }
              });
            }
          });
        this.setState({
          registerBtnDisabled: false
        });
      }
    );
  };

  aszfCheckbox() {
    this.setState({
      aszfConfirmed: !this.state.aszfConfirmed
    });
  }

  render() {
    // const lang = localStorage.getItem("clavis.language").toLowerCase();
    const lang = this.state.language.value.toLowerCase();
    return (
      <div className="registration page-header-background-color">
        <div className="registration-page">
          <div className="content">
            <div className="header-logo application-header-logo-66" />
            <div className="title huge-font-medium page-header-color ">
              {lang === "hu" ? "Regisztráció" : "Registration"}

              <div className={"language"}>
                <SimpleDropdown
                  labelPrefix={"platform.Login.language."}
                  direction="down"
                  labelProperty="name"
                  data={this.state.availableLanguages}
                  selected={this.state.language}
                  onSelected={selected => {
                    this.setState({ language: selected });
                    localStorage.setItem("clavis.language", selected.value);
                  }}
                  maxItem={7}
                />
              </div>
            </div>
            {!this.state.showVerifyForm && (
              <div>
                {this.props.actionType === "registration" && (
                  <div className="registration-info huge-font-medium page-header-color">
                    {lang === "hu"
                      ? "Ön most regisztrálja magát az Elektronikus Alvállalkozói Nyilvántartásba.\n" +
                        "Kérjük adjon meg egy felhasználónevet és jelszót, amivel használni szeretné a rendszert!"
                      : "You are now registering in the Electronic Subcontractor Register.\n" +
                        "Please enter a username and password with which you would like to use the system!"}
                  </div>
                )}
              </div>
            )}
            {!this.state.token && (
              <div className="registration-box interaction-background-color">
                <div className={"normal-font-regular failed-color error"}>
                  {lang === "hu"
                    ? "Az emailben küldött token szükséges!"
                    : "The token sent in the email is required!"}
                </div>
              </div>
            )}

            {this.state.token && this.state.showVerifyForm && (
              <div
                className="registration-box interaction-background-color"
                onKeyDown={this.handleKeyPressVerify}
              >
                <div className="title normal-font-medium">
                  {lang === "hu"
                    ? "Belépési kód megadása"
                    : "Enter access code"}
                </div>
                <div className="username">
                  <Input
                    className="active"
                    label={lang === "hu" ? "Sms kód" : "Sms code"}
                    value={this.state.smsOtp}
                    warning={this.state.warningSmsOtp}
                    onChange={event => {
                      this.changeSmsOtp(event);
                    }}
                    id="smsOtp"
                    type={"number"}
                    min={6}
                    max={6}
                  />
                </div>
                <div className="sign-in">
                  <Button
                    buttonType="primary"
                    disabled={
                      this.state.verifyBtnDisabled ||
                      this.state.smsOtp.length !== 6
                    }
                    click={() => this.confirm()}
                  >
                    {lang === "hu" ? "Elfogadás" : "Confirm"}
                  </Button>
                </div>
                <div className="send-again">
                  {this.state.sendAgainLoading && (
                    <LoadingIndicator size={"extra-small"} />
                  )}
                  {!this.state.sendAgainLoading && (
                    <Link onClick={() => this.sendSmsOtp()}>
                      {lang === "hu" ? "Újra küld" : "Send again"}
                    </Link>
                  )}
                </div>
              </div>
            )}

            {!this.state.showVerifyForm && (
              <div className="registration-box interaction-background-color">
                <div className="title normal-font-medium">
                  {lang === "hu" ? "Bejelentkezési adatok" : "Login details"}
                </div>
                {this.props.actionType !== "changePassword" && (
                  <div className="username">
                    <Input
                      className="active"
                      label={lang === "hu" ? "Felhasználónév" : "Username"}
                      value={this.state.username}
                      warning={this.state.warningUsername}
                      onChange={event => {
                        this.changeUsername(event);
                      }}
                      id="name"
                    />
                  </div>
                )}
                <div className="password ">
                  <Input
                    type="password"
                    onChange={event => {
                      this.changePassword(event);
                    }}
                    label={lang === "hu" ? "Jelszó" : "Password"}
                    value={this.state.password}
                    warning={this.state.warningPassword}
                    inputIconClassName={
                      "icon-faq icon-small input-icon-register"
                    }
                    iconTitle={
                      lang === "hu"
                        ? "A jelszónak legalább 10 karakter hosszúságúnak kell lennie, tartalmaznia kell kis, nagy betűt és egy számot!"
                        : "The password must be at least 10 characters long and include lowercase letters, uppercase letters, and at least one number!"
                    }
                  />
                </div>
                <div
                  className="password"
                  onKeyDown={this.handleKeyPressRegistration}
                >
                  <Input
                    type="password"
                    onChange={event => {
                      this.changePasswordAgain(event);
                    }}
                    label={lang === "hu" ? "Jelszó újra" : "Password again"}
                    value={this.state.passwordAgain}
                    warning={this.state.warningPasswordAgain}
                  />
                </div>
                {this.props.actionType === "registration" && lang === "hu" && (
                  <div className="checkbox-message-for-me custom-checkbox custom-controll">
                    <input
                      id={"cbox"}
                      className={"custom-control-input"}
                      type={"checkbox"}
                      checked={this.state.aszfConfirmed}
                      onChange={() => {
                        this.aszfCheckbox();
                      }}
                    />
                    <label htmlFor="cbox" className="custom-control-label">
                      <span className="checkbox-text">
                        A{" "}
                        <a
                          href="https://hunfedezetkezelo.hu/adatvedelem/"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={e => e.stopPropagation()}
                          className={"aszf-link"}
                        >
                          HUNFedezetkezelő Zrt.
                        </a>{" "}
                        honlapján található érvényes Adatkezelési Tájékoztatót
                        elfogadom.
                      </span>
                    </label>
                  </div>
                )}
                {this.props.actionType === "registration" && lang === "en" && (
                  <div className="checkbox-message-for-me custom-checkbox custom-controll">
                    <input
                      id={"cbox"}
                      className={"custom-control-input"}
                      type={"checkbox"}
                      checked={this.state.aszfConfirmed}
                      onChange={() => {
                        this.aszfCheckbox();
                      }}
                    />
                    <label htmlFor="cbox" className="custom-control-label">
                      <span className="checkbox-text">
                        I accept the Privacy Policy available on the{" "}
                        <a
                          href="https://hunfedezetkezelo.hu/adatvedelem/"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={e => e.stopPropagation()}
                          className={"aszf-link"}
                        >
                          HUNFedezetkezelő Zrt.
                        </a>{" "}
                        website.
                      </span>
                    </label>
                  </div>
                )}
                <div className="sign-in">
                  {this.props.actionType === "registration" && (
                    <Button
                      buttonType="danger"
                      click={() => navigateToAuthorizeEndpoint()}
                    >
                      {lang === "hu" ? "Mégsem" : "Cancel"}
                    </Button>
                  )}
                  {this.props.actionType === "registration" && (
                    <Button
                      buttonType="primary"
                      disabled={
                        !(
                          this.state.token &&
                          this.state.username &&
                          this.state.password &&
                          this.state.passwordAgain &&
                          this.state.aszfConfirmed
                        )
                      }
                      click={() => this.registration()}
                    >
                      {lang === "hu" ? "Elfogadás" : "Confirm"}
                    </Button>
                  )}
                  {this.props.actionType === "changePassword" && (
                    <Button
                      buttonType="primary"
                      disabled={
                        !(
                          this.state.token &&
                          this.state.password &&
                          this.state.passwordAgain
                        )
                      }
                      click={() => this.changePasswordSend()}
                    >
                      {lang === "hu" ? "Elfogadás" : "Confirm"}
                    </Button>
                  )}
                </div>
              </div>
            )}
            <div className="version">
              <div className="version-title page-header-color small-font-regular ">
                {lang === "hu"
                  ? `VERZIÓ: ${
                      JSON.parse(localStorage.getItem("environment"))
                        .applicationVersion
                    } (${process.env.REACT_APP_VERSION})`
                  : `VERSION: ${
                      JSON.parse(localStorage.getItem("environment"))
                        .applicationVersion
                    } (${process.env.REACT_APP_VERSION})`}
              </div>
              <i className="icon-info icon-small page-header-color" />
            </div>
          </div>
          <div className="footer ">
            <div className="footer-logo " />
            <div className="subtitle page-header-color small-font-regular ">
              {lang === "hu"
                ? "Elektronikus Fedezetkezelői Nyilvántartás"
                : "Electronic Collateral Management Register"}
            </div>
            <div>
              <div className="copyright page-header-color small-font-regular">
                © Copyright {moment().format("YYYY")} HUNFedezetkezelő Zrt.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default router(translate()(Registration));
